module.exports = __webpack_public_path__ + "static/media/import-modal.afa75b22.png";